import { useState, useEffect } from "react";
import { Modal, ModalHeading, ModalFooter } from "@biteship/atom";
import ExpressRatesForm from "./ExpressRatesForm";
import InstantRatesForm from "./InstantRatesForm";
import { isAuthenticated } from "../../../../store/action/auth";
import { createRates, updateRates } from "../../../../store/action/rates";
import { inputValidation } from "../../../../services/helpers/validation";

export default function ModalRatesForm(props) {
  const { token, user } = isAuthenticated();
  const courierType = user.courier ? user.courier.courierType : "express";
  const [loading, setLoading] = useState(false);
  const [inputType, setInputType] = useState({
    title: "Pilih jenis input yang diinginkan...",
    value: "",
  });

  let inputInitialState = {
    origin: "",
    destination: "",
    basePrice: "",
    weightExtraPrice: "",
    volumeExtraPrice: "",
  };

  if (courierType !== "express")
    inputInitialState = {
      ...inputInitialState,
      originLat: "",
      originLng: "",
      destinationLat: "",
      destinationLng: "",
      distanceExtraPrice: "",
    };

  const [inputData, setInputData] = useState(inputInitialState);

  useEffect(() => {
    if (props.data)
      setInputData({
        ...inputData,
        basePrice: props.data.price,
        weightExtraPrice: props.data.price_per_kg,
        volumeExtraPrice: props.data.price_per_vol,
        distanceExtraPrice: props.data.price_per_km,
      });
  }, [props.data]);

  const onSubmitCreate = async () => {
    try {
      setLoading(true);
      const resVal = inputValidation(inputData, courierType, "create", inputType.value);
      if (resVal.error) {
        alert(resVal.message);
        setLoading(false);
        return;
      }
      const res = await createRates(token, inputType.value, inputData, courierType);
      setLoading(false);
      if (!res.success) {
        alert("Gagal membuat rates. Silahkan coba kembali");
        setLoading(false);
        return;
      }
      alert("Berhasil membuat rates. Anda akan diarahkan ke halaman utama");
      window.location.reload();
    } catch (error) {
      console.log(error);
      setLoading(false);
      alert("Gagal membuat rates. Silahkan coba kembali");
    }
  };
  const onSubmitEdit = async () => {
    try {
      setLoading(true);
      const resVal = inputValidation(inputData, courierType, "edit", inputType.value);
      if (resVal.error) {
        alert(resVal.message);
        setLoading(false);
        return;
      }
      const res = await updateRates(token, props.data, inputData);
      setLoading(false);
      if (!res.success) {
        alert("Gagal mengubah rates. Silahkan coba kembali");
        setLoading(false);
        return;
      }
      alert("Berhasil mengubah rates. Anda akan diarahkan ke halaman utama");
      window.location.reload();
    } catch (error) {
      console.log(error);
      setLoading(false);
      alert("Gagal mengubah rates. Silahkan coba kembali");
    }
  };

  const onSubmit = () => {
    if (props.useType === "edit") {
      onSubmitEdit();
    } else {
      onSubmitCreate();
    }
  };

  return (
    <Modal onClose={props.onClose} size="lg" show={props.show}>
      <ModalHeading
        title={props.useType === "create" ? "Tambah Rates" : "Edit Rates"}
        onClose={props.onClose}
      />
      {courierType === "express" ? (
        <ExpressRatesForm
          inputType={inputType}
          setInputType={setInputType}
          inputData={inputData}
          setInputData={setInputData}
          useType={props.useType}
        />
      ) : (
        <InstantRatesForm
          inputData={inputData}
          setInputData={setInputData}
          useType={props.useType}
        />
      )}

      <ModalFooter
        primaryButton={{ loading: loading, title: "Submit", onClick: () => onSubmit() }}
      />
    </Modal>
  );
}
